import jsPDF from "jspdf";
import {
    store
} from "../../index";
import moment from "moment";
import Roundy from "../../services/roundy";
import {
    imgData
} from "./letterhead";
const pdfdownload = tnms => {
    var first_tm = tnms[0]
    var last_tm = tnms[tnms.length - 1]
    var doc = new jsPDF();

    var employees = store.getState().employees.employees;
    // You'll need to make your image into a Data URL
    // Use http://dataurl.net/#dataurlmaker
    tnms.forEach(function (tnminfo, tmindex) {

        var index = 0;
        var arrayLength = tnminfo.entries.length;
        var chunk_size = 10;
        var sheetNum = 1;
        var sheetcount = Math.ceil(arrayLength / chunk_size);
        console.log('index', index);

        if (tmindex) {
            doc.addPage();
        }

        for (index = 0; index < arrayLength; index += chunk_size) {
            let entryChunk = tnminfo.entries.slice(index, index + chunk_size);
            // Do something if you want with the group
            if (sheetNum > 1) {
                doc.addPage();
            }


            // Header Image
            doc.addImage(imgData, "JPEG", 15, 10, 113, 22);
            doc.setFontSize(12);
            doc.setFont("helvetica");
            doc.setFontType("bold");
            doc.text(150, 15, "8390 Currency Dr.");
            doc.text(135, 20, "Riviera Beach Fl. 33404 Unit 4");
            doc.text(147, 25, "Phone: 561-844-8886");
            doc.text(150, 30, "Fax: 561-842-3929");

            // HR
            doc.setLineWidth(0.5);
            doc.line(15, 40, 200, 40);

            doc.setFontSize(14);
            doc.setFont("helvetica");
            doc.setFontType("bold");
            doc.text(
                25,
                48,
                "Time and material Charges Report for " + tnminfo.customer.custname
            );
            doc.text(
                25,
                54,
                "Created on " + moment(tnminfo.createdate).format("MM/DD/YYYY")
            ); // #Create_Date
            // Header
            doc.setFontSize(12);
            doc.setFont("helvetica");
            doc.setFontType("bold");
            doc.text(20, 62, "Written for:");
            doc.setFontType("normal");
            doc.text(44, 62, tnminfo.customer.custname);

            doc.setFontType("bold");
            doc.text(140, 62, "T&M Number:");
            doc.setFontType("normal");
            doc.text(169, 62, tnminfo.tmnumber);

            doc.setFontType("bold");
            doc.text(20, 67, "Purchase Order No:");
            doc.setFontType("normal");
            doc.text(61, 67, tnminfo.wod.poNbr);

            doc.setFontType("bold");
            doc.text(140, 67, "Acc No:");
            doc.setFontType("normal");
            doc.text(157, 67, tnminfo.wod.acctNbr ? tnminfo.wod.acctNbr : "");

            doc.setFontType("bold");
            doc.text(20, 72, "Date:");
            doc.setFontType("normal");


            doc.setFontType("bold");
            doc.text(140, 72, "TJA #:");
            doc.setFontType("normal");
            doc.text(154, 72, tnminfo.wod.tjaNbr ? tnminfo.wod.tjaNbr : "");

            doc.setFontType("bold");
            doc.text(20, 77, "EDF #:");
            doc.setFontType("normal");
            doc.text(35, 77, tnminfo.wod.workOrderNbr);

            doc.setFontType("bold");
            doc.text(20, 82, "Job Description:");
            doc.setFontType("normal");
            doc.text(54, 82, tnminfo.wod.description);

            // HR
            doc.setLineWidth(0.5);
            doc.line(15, 87, 200, 87);

            // Titles
            doc.setFontType("bold");
            doc.text(15, 94, "Date");
            doc.text(35, 94, "Name");
            doc.text(85, 94, "Classification");
            doc.text(130, 94, "Hours");
            doc.text(155, 94, "Rate");
            doc.text(178, 94, "Amount");

            // Time Entrys
            // +6 pt in Y directopm per entry
            doc.setFontType("normal");
            var lastrow;
            // Time Example
            var totalhours = 0;
            entryChunk.map((entry, index) => {
                var row = 100;
                if (entry.hours && entry.hours > 0) {
                    totalhours += entry.hours;

                    entry.payrate = parseFloat(entry.payrate).toFixed(2);
                    let employee = employees.find(emp => emp.empnumber === entry.empnumber);
                    row += index * 6;
                    lastrow = row;
                    // labor entry
                    console.log("LABOR Entry", entry)
                    doc.text(15, row, moment(entry.dateperformed).format("MM/DD/YY"));
                    // doc.text(15, row, "TESTING");
                    doc.text(35, row, entry.empname);
                    doc.text(85, row, employee.discipline.replace(",", ""));
                    doc.text(130, row, entry.hours.toString());
                    doc.text(155, row, entry.payrate);
                    doc.text(178, row, "$" + (entry.hours * entry.payrate).toFixed(2));
                } else if (entry.matname) {
                    row += index * 6;
                    lastrow = row;
                    // material entry
                    doc.text(15, row, moment(entry.wedate).format("MM/DD/YY"));
                    doc.text(35, row, entry.matname);
                    doc.text(85, row, "Material");
                    doc.text(130, row, "-");
                    doc.text(155, row, "$" + entry.amount);
                    doc.text(178, row, "$" + entry.amount);
                }
            });
            // Material Eaample

            if (sheetNum === sheetcount) {
                // Subtotal Example
                var budget = parseFloat(tnminfo.wod.budget);
                if (tnminfo.wod.supplements) {
                    let supplements = parseFloat(tnminfo.wod.supplements);
                    console.log("Supplements", supplements);
                    budget += supplements;
                    console.log(budget);
                }
                if (tnminfo.wod.prevYearAdj) {
                    budget -= parseFloat(tnminfo.wod.prevYearAdj);
                }

                doc.setFontType("bold");
                doc.text(80, lastrow + 6, "This Sheet Total Hours:");
                doc.setFontType("normal");
                doc.text(130, lastrow + 6, Roundy(totalhours).toString());
                doc.setFontType("bold");
                doc.text(150, lastrow + 6, "TM Total:");
                doc.setFontType("normal");
                doc.text(177, lastrow + 6, "$" + Roundy(parseFloat(tnminfo.amount)));

                doc.setFontType("bold");
                doc.setFontType("normal");
                doc.setTextColor(255, 0, 0);
                doc.setTextColor(0, 0, 0);
                doc.setFontType("bold");

                doc.setFontType("normal");

                let remaining =
                    budget - (parseFloat(tnminfo.prevtmtotal) + parseFloat(tnminfo.amount));
                if (remaining < 0) {
                    doc.setTextColor(255, 0, 0);
                }
                remaining = Roundy(remaining);
                doc.setTextColor(0, 0, 0);
                // Footer
                doc.text(15, 230, "Signed:");
                doc.line(32, 230, 105, 230);
                doc.text(110, 230, "Approved:");
                doc.line(131, 230, 200, 230);

                doc.text(45, 236, "Supplier Representative");
                doc.text(142, 236, "Customer Representative");

                doc.setFontType("bold");
                doc.text(15, 248, "COPY FOR");
                doc.setFontType("normal");
                doc.text(25, 256, "Accounts Payable");
                doc.text(80, 256, "Non-Product");
                doc.text(120, 256, "Supplier");
                doc.text(170, 256, "Originator");
                doc.text(100, 266, "(Sheet " + sheetNum + " of " + sheetcount + ")");
            } else {
                doc.text(100, 266, "(Sheet " + sheetNum + " of " + sheetcount + ")");
            }
            sheetNum += 1;
        }

    });
    doc.save(first_tm.wod.workOrderNbr + " T&M " + moment(first_tm.wedate).format("MM-DD-YY") + " through " + moment(last_tm.wedate).format("MM-DD-YY") + ".pdf");
};

export default pdfdownload;


// WEBPACK FOOTER //
// ./src/components/pdf/tnmPDFDownloadmulti.js